import { makeAutoObservable } from 'mobx';
import type { PrayerItem } from '@skjv/common';
import { savePrayerItems, loadPrayerItems } from '../persistence';

/**
 * Prayer items state management.
 */
export class PrayerState {
  /** Prayer items */
  prayerItems: PrayerItem[] = [];

  constructor() {
    makeAutoObservable(this);

    if (typeof window !== 'undefined') {
      this.prayerItems = loadPrayerItems<PrayerItem>();
    }
  }

  /** Add a prayer item */
  addPrayerItem(description: string): void {
    const item: PrayerItem = {
      id: crypto.randomUUID(),
      order: this.prayerItems.length,
      description,
    };
    this.prayerItems = [item, ...this.prayerItems];
    this.save();
  }

  /** Remove a prayer item */
  removePrayerItem(id: string): void {
    this.prayerItems = this.prayerItems.filter((p) => p.id !== id);
    this.save();
  }

  /** Reorder prayer items */
  reorderPrayerItems(items: PrayerItem[]): void {
    this.prayerItems = items;
    this.save();
  }

  /** Import prayer items (merges by description) */
  importPrayerItems(items: PrayerItem[]): number {
    let count = 0;
    for (const item of items) {
      const exists = this.prayerItems.some((p) => p.description === item.description);
      if (!exists) {
        this.prayerItems.push({
          id: item.id || crypto.randomUUID(),
          order: item.order ?? this.prayerItems.length,
          description: item.description,
        });
        count++;
      }
    }
    this.save();
    return count;
  }

  private save(): void {
    savePrayerItems(this.prayerItems);
  }
}
